/* YG Home — Testimonials video cards.
   Click-to-play/pause, matching the reference's own nss-video-card.js
   (read in full — a ~1KB custom element) — confirmed NOT autoplay: no
   muted/autoplay attributes anywhere in source, preload="metadata" only.
   Reproduced here as plain event listeners rather than a custom element,
   since nothing else needs the custom-element registration.

   pauseOthers(): matches source's own pauseOtherCards() — scoped to the
   containing carousel (closest .yg-carousel, mirroring source's own
   closest('nss-carousel')), not the whole page — only one video per
   carousel instance plays at a time; clicking a second one pauses whichever
   was already playing in that same carousel.

   `players` is module-level, not re-created per init() call: a block left
   without a video yet (ships as a plain poster/placeholder) only gets a
   real <video>/toggle once the merchant uploads one, and a later
   shopify:section:load re-render must still find every OTHER already-
   initialized card to pause correctly — a fresh empty array per call would
   silently break cross-card mutual exclusion between cards initialized on
   different passes. Same reasoning for reusing one IntersectionObserver
   instance rather than creating a new one (and re-observing already-tracked
   cards) on every call.

   IntersectionObserver: the ONE deliberate addition beyond source, per
   explicit (corrected) instruction — its only job is pausing a playing
   video once it scrolls out of view. It does NOT autoplay anything back in
   — the reference is click-to-play and autoplay-on-view was explicitly
   withdrawn as a requirement after re-checking source, since that would be
   a behaviour change (and a real performance/accessibility cost), not a
   port. */
(function () {
  'use strict';

  var players = [];
  var observer = null;

  function pauseOthersIn(carouselRoot, video) {
    players.forEach(function (p) {
      if (p.video === video) return;
      if (carouselRoot && p.carouselRoot !== carouselRoot) return;
      if (!p.video.paused) p.video.pause();
    });
  }

  function init(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.yg-tst-card--video');
    if (!cards.length) return;

    if (!observer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          var match = players.filter(function (p) { return p.card === entry.target; })[0];
          if (match && !match.video.paused) match.video.pause();
        });
      }, { threshold: 0 });
    }

    cards.forEach(function (card) {
      if (card.__ygTstInit) return;

      var video = card.querySelector('[data-yg-tst-video]');
      var toggle = card.querySelector('[data-yg-tst-toggle]');
      // Deliberately NOT flagged as initialized until a real video/toggle
      // exist to attach to — a card without either yet must stay eligible
      // for this to run again once a video is actually uploaded, rather
      // than being permanently skipped from the one early call that found
      // nothing.
      if (!video || !toggle) return;
      card.__ygTstInit = true;

      var carouselRoot = card.closest('.yg-carousel');

      toggle.addEventListener('click', function () {
        if (video.paused) {
          pauseOthersIn(carouselRoot, video);
          video.play();
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', function () {
        pauseOthersIn(carouselRoot, video);
        card.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        card.classList.remove('is-playing');
      });

      players.push({ card: card, video: video, carouselRoot: carouselRoot });
      if (observer) observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
